jQuery(function($) {
    ///////////////////////////////////////////////////////////////////////////
    // Common                                                                //
    ///////////////////////////////////////////////////////////////////////////
    var $selectorContainer = $('.vehicle-selectors');

    // Listeners for closing dropdowns when off clicks happen.
    $('body').on('click', function(e) {
        if(!$(e.target).parents('.selector-wrapper').length) {
            $selectorContainer.find('.option-container').hide();
            $selectorContainer.find('.selector-button').removeClass('active');
        }
    });

    $selectorContainer.on('click', '.selector-button', function(e) {
        e.preventDefault();
        var $optionContainer = $(this).parent().find('.option-container');
        if($optionContainer.is(':visible')) {
            $optionContainer.hide();
            $(this).removeClass('active');
        }
        else {
            $optionContainer.show();
            $(this).addClass('active');
        }
    });

    ///////////////////////////////////////////////////////////////////////////
    // Navigation Selector                                                   //
    ///////////////////////////////////////////////////////////////////////////
    var selectedVehicleUrl = null;
    var vehicleList = headVehicleMenu.filter(function(item) {
        return item.label === 'Choose BMW';
    });

    // Populate the series dropdown
    vehicleList[0].children.forEach(function(item){
        $selectorContainer.find('.selector-series').find('.option-container').append(buildOptionItem(item));
    });

    $selectorContainer.find('.selector-series').find('.option-item').on('click', function(e) {
        e.preventDefault();

        var url = $(this).attr('id');
        var menu = getModelMenu(url);

        var $modelSelector = $selectorContainer.find('.selector-model');
        var $modelButton = $modelSelector.find('.selector-button');

        var $seriesSelector = $selectorContainer.find('.selector-series');
        var $seriesButton = $seriesSelector.find('.selector-button');

        $seriesButton.removeClass('active');
        $seriesButton.find('span').html(menu.label);
        $seriesSelector.find('.option-container').hide();

        if(!menu.children){
            selectedVehicleUrl = $(this).attr('id');
            $modelSelector.hide();
            window.location = selectedVehicleUrl;
            return;
        }

        $modelSelector.show();
        $modelButton.prop('disabled', false);
        $modelButton.find('span').html('Model');
        $modelSelector.find('.option-container').html('');
        menu.children.forEach(function(item){
            $modelSelector.find('.option-container').append(buildOptionItem(item));
        });

        $modelSelector.find('.option-item').on('click', function(e){
            selectedVehicleUrl = $(this).attr('id');
            $modelButton.removeClass('active');
            $modelButton.find('span').html($(this).html());
            $modelSelector.find('.option-container').hide();
            window.location = selectedVehicleUrl;
        });
    });

    function buildOptionItem(item) {
        var $tpl = $($('.vehicle-link-template').clone().html());
        $tpl.html(item.label);
        $tpl.attr('id', item.URL);
        return $tpl;
    }

    function getModelMenu(url){
        var result = vehicleList[0].children.filter(function(item){
            if(item.URL === url){
                return item;
            }
        });
        return result[0];
    }

    ///////////////////////////////////////////////////////////////////////////
    // Chassis Selector                                                      //
    ///////////////////////////////////////////////////////////////////////////
    $selectorContainer.find('.selector-chassis').find('.option-item').on('click', function(e) {
        e.preventDefault();

        var $selector = $(this).parents('.selector-wrapper');
        var $button = $selector.find('.selector-button');

        $button.removeClass('active');
        $button.find('span').html($(this).html());
        $selector.find('.option-container').hide();

        var extra = $(this).attr('id');
        var redirectURL = window.location.href.replace(/ResultPage=\d+/, 'ResultPage=0');
        $.get('/setVehicleGroup', { ShortURL: extra }, function() {
            window.location.href = redirectURL;
        });
    });

}(jQuery));
